module.exports = __webpack_public_path__ + "static/media/mymovein.2feba2fc.png";